const apiUrl = "REACT_APP_API_URL" in process.env ? process.env.REACT_APP_API_URL : 'https://api.connome.com/api/'
const samRootUrl = "REACT_APP_CALLBACK_URL" in process.env ? process.env.REACT_APP_CALLBACK_URL : 'account_STOP_sikomliving_STOP_com'

export function get(query, credentials, onDataReceived) {
    doHttpCall('GET', query, null, credentials, onDataReceived);
}

export function post(query, body, credentials, onDataReceived) {
    doHttpCall('POST', query, body, credentials, onDataReceived);
}

function doHttpCall(method, query, body, credentials, onDataReceived) {
    if (!query.includes('Password') && !query.includes('Receipts')) {
        console.log("Request: " + query);
    }

    const emptyCredentials = {
        email: '',
        password: ''
    }

    let convertedCredentials;
    if (credentials !== null) {
        convertedCredentials = {
            email: credentials.email,
            password: credentials.password + '!!!'
        }
    }

    const credentialsToSend = credentials === null ? emptyCredentials : convertedCredentials
    const myHeaders = new Headers({
        'Authorization': 'Basic ' + btoa(credentialsToSend.email + ':' + credentialsToSend.password),
        'Content-Type': 'application/x-www-form-urlencoded',
    });

    let myInit;
    if (method === 'GET') {
        myInit = {
            headers: myHeaders,
            method: method
        };
    } else if (method === 'POST') {
        myInit = {
            headers: myHeaders,
            method: method,
            body: body
        };

    } else {
        return;
    }

    fetch(apiUrl + query, myInit)
        .then(function (response) {
            if (response.status !== 401) {
                return response.json();
            } else {
                console.log("Response status: " + response.status);
            }
        })
        .then(function (data) {
            // Return bpapi_result (where the relevant the data is located)
            // Note that not all responses have bpapi_result in the Data object,
            // so we must instead pass Data.
            onDataReceived(data.Data);
        })
        .catch(function (error) {
            console.log('Something bad happened: ' + error);
            onDataReceived(null);
        });
}

export function encode(parameter) {
    // Null and empty values should just be a space
    if (parameter == null || parameter === '') {
        return " ";
    }

    return encodeURIComponent(parameter);
}

function encodeOld(parameter) {
    // Null and empty values should just be a space
    if (parameter == null || parameter === '') {
        return " ";
    }

    let result = parameter;
    result = result.replace(/\-/g, "_DASH_").replace(/\:/g, "_COLON_").replace(/\//g, "_SLASH_").replace(/\#/g, "_HASH_").replace(/\%/g, "_PERCENT_").replace(/\+/g, "_PLUS_").replace(/\&/g, "_AMP_").replace(/\./g, "_STOP_").replace(/\*/g, "_STAR_").replace(/\?/g, "_QUESTION_").replace(/\'/g, "_APOSTROPHE_");
    result = encodeURI(result);
    return result;
}

/**
 * 
 * @param {credentials.email can be value code or email} credentials 
 * @param {*} onOk 
 * @param {*} onError 
 */
export function verifyPassword(credentials, isValueCode, onAccessGranted, onError) {
    const query = 'VerifyPassword';
    const body = 'email=' + credentials.email + '&password=' + encodeURIComponent(credentials.password) + '!!!'

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }
        if (Data.bpapi_status === 'ok') {
            const accessType = Data.bpapi_result.access_granted;
            switch (accessType) {
                case 'FullAccess':
                    onAccessGranted(accessType);
                    break;
                case 'LimitedAccessRegistrationIdUsed':
                    onAccessGranted(accessType);
                    break;
                case 'NoAccess':
                    onError(isValueCode);
                    break;
                default:
                    onError(isValueCode);
                    break;
            }
        } else {
            onError();
        }
    }

    post(query, body, null, onDataReceived);
}

// This method will fail if the password contains the character "¤". Might be others as well.
// For now, we simply setLoading(false) if this method fails.
export function getAppView(credentials, access_granted, onOk, onError) {
    const onDataReceived = function response(Data) {
        if (Data == null) {
            console.log("Could not get AppView");
            onError();
            return;
        }

        if (Data.bpapi_status === "ok") {
            // If we have multiple gateways, we will never log in automatically as password is needed
            const hasMultipleGateways = Data.bpapi_result.gateways.length > 1;
            onOk(Data.bpapi_result, access_granted, hasMultipleGateways);
        } else {
            console.log("bpapi error");
        }
    }

    if (access_granted === 'LimitedAccessRegistrationIdUsed') {
        console.log("Limited access granted");
        // Limited access does not need credentials
        get('AppViewSimple/v2.1/' + credentials.email + '/' + credentials.password + '/', null, onDataReceived);
    } else {
        console.log("Full access granted");
        get('AppView/v2.1/', credentials, onDataReceived);
    }

}

export function updateAppData(credentials, limitedAccess, onDataUpdated) {
    console.log("Updating AppData");
    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === "ok") {
            onDataUpdated(Data.bpapi_result);
        } else {
            console.log("bpapi error");
        }
    }

    if (limitedAccess) {
        get('AppViewSimple/v2.1/' + credentials.email + '/' + credentials.password + '/', null, onDataReceived);
    } else {
        get('AppView/v2.1/', credentials, onDataReceived);
    }
}

export function changePassword(email, old_password, new_password, onOk, onError) {
    const query = 'ChangePassword'
    const body = 'email=' + email + '&old_password=' + encodeURIComponent(old_password) + '!!!' + '&new_password=' + encodeURIComponent(new_password) + '!!!'

    const onDataReceived = function response(Data) {
        if (Data == null) {
            console.log("Data is null");
            onError();
            return;
        }

        if (Data.bpapi_status === 'ok') {
            console.log("Password changed");
            onOk();
        } else {
            console.log("Error: " + Data.bpapi_status);
            onError();
        }
    }

    post(query, body, null, onDataReceived);
}

export function changeEmail(email, password, new_email, execute_id, onOk, onError) {
    const query = 'ChangeEmail'
    const body = 'old_email=' + email + '&password=' + encodeURIComponent(password) + '!!!' + '&new_email=' + new_email + '&execute_id=' + execute_id

    const onDataReceived = function response(Data) {
        if (Data == null) {
            console.log("Data is null");
            onError();
            return;
        }

        if (Data.bpapi_status === 'ok' && Data.bpapi_result.error == null) {
            console.log("Email changed");
            const is_execute_id_sent = Data.bpapi_result.is_execute_id_sent;
            const is_email_changed = Data.bpapi_result.is_email_changed;
            onOk(is_execute_id_sent, is_email_changed);
        } else {
            console.log("Error: " + Data.bpapi_status);
            const error = Data.bpapi_result.error;
            onError(error);
        }
    }

    post(query, body, null, onDataReceived);
}

// Todo: Change to POST?
export function setCustomerProperty(usingValueCode, credentials, propertyName, propertyValue, valueCode, onOk, onError) {
    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === 'ok') {
            onOk();
        } else {
            console.log("client_error");
            onError();
        }
    }

    let query;
    let body;
    if (usingValueCode) {
        query = 'Customer/AddPropertySimple'
        body = 'registration_id=' + valueCode + '&property_name=' + propertyName + '&value=' + encodeURIComponent(propertyValue);
        post(query, body, null, onDataReceived);
    } else {
        query = 'Customer/AddProperty'
        body = 'property_name=' + propertyName + '&value=' + encodeURIComponent(propertyValue);
        post(query, body, credentials, onDataReceived);
    }
}

/**
 * This method can return many different bpapi_statuses.
 * See: https://api.connome.com/documentation/CustomerAdd.html.
 * Note that the documentation for this method is not complete as of 27.08.2018
 * 
 * Irrelevant ok responses:
 * "ok_customer_already_existed" (only relevant when <paramref name="registration_id"/> not given. Means "Customer already existed with identical password. No changes have been made").
 * "ok_added_as_child" (only relevant for <paramref name="addAsChild"/>
 * "ok_added_as_child_last_name_set" (only relevant for <paramref name="addAsChild"/> and with <paramref name="password"/> not given)
 * "ok_organization_name_set" (only relevant when not <paramref name="addAsChild"/> and <paramref name="password"/> not given)
 * "ok_only_customer_added" (only relevant when <paramref name="registration_id"/> not given.
 * "ok_customer_already_existed" (only relevant when <paramref name="registration_id"/> not given.
 * 
 * Relevant ok responses:
 * "ok_customer_already_existed_gateway_registered_on_the_existing_customer" ("The "normal" (but rare) occurrence when customer has multiple gateways. Means that the old "value-code" customer will have been marked "inactive")
 * "ok_gateway_registered_on_value_code_customer" (The most "normal" variant for a real first registration for a customer. The existing "dummy" value-code customer registered with the gateway was changed with the new credentials given)
 * "ok_customer_already_existed_and_gateway_already_registered" (The most "normal" variant for a repeated / duplicate registration)
 * 
 * Relevant error responses:
 * "invalid_registration_id_data_error"
 * "gateway_already_registered_data_error"
 * "illegal_password_data_error"
 * "email_address_already_in_use_data_error"
 * 
 * @param {*} email 
 * @param {*} password 
 * @param {*} registration_id 
 * @param {*} onResponse 
 */
export function addCustomer(email, password, registration_id, onOk, onError) {
    const query = 'Customer/Add/'
    const body = 'email=' + email + '&password=' + password + '!!!' + '&registration_id=' + encodeURIComponent(registration_id);

    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_status, Data.bpapi_result.ok_detailed_information);
        } else {
            onError(Data.bpapi_status);
        }
    }

    post(query, body, null, onDataReceived);
}

/**
 * 
 * @param {*} registration_id 
 * @param {*} first_name 
 * @param {*} last_name 
 * @param {*} mobile_phone 
 * @param {*} dealer_name 
 * @param {*} address_1 
 * @param {*} address_2 
 * @param {*} postal_code 
 * @param {*} city 
 * @param {*} country 
 * @param {*} organization_name 
 * @param {*} location_installed TIP: Keep location_installed as last parameter. Will increase change of catching bug with mismatched ordering of parameters.
 * @param {*} onOk 
 * @param {*} onError 
 */
export function addCustomerPropertyMultiple(usingValueCode, credentials, first_name, last_name, mobile_phone, dealer_name, address_1, address_2, postal_code, city, country, organization_name, location_installed, onOk, onError) {
    /*
    Simple query will be used if we are logged in with value code.
    This takes in registration_id (stored in credentials.email) as the first parameter.

    Normal query will be used if we are logged in with email and password.
    This does not take in registration_id, but adds credentials to header information instead.
    */

    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === 'ok') {
            onOk();
        } else {
            console.log("client_error");
            onError();
        }
    }

    let query;
    let body;
    if (usingValueCode) {
        query = 'Customer/AddPropertyMultipleSimple'
        body =
            'registration_id=' + encode(credentials.email) +
            '&first_name=' + encode(first_name) +
            '&last_name=' + encode(last_name) +
            '&mobile_phone=' + encode(mobile_phone) +
            '&dealer_name=' + encode(dealer_name) +
            '&address_1=' + encode(address_1) +
            '&address_2=' + encode(address_2) +
            '&postal_code=' + encode(postal_code) +
            '&city=' + encode(city) +
            '&country=' + encode(country) +
            '&organization_name=' + encode(organization_name) +
            '&location_installed=' + encode(location_installed)
        post(query, body, null, onDataReceived);
    } else {
        query = 'Customer/AddPropertyMultiple'
        body =
            'first_name=' + encode(first_name) +
            '&last_name=' + encode(last_name) +
            '&mobile_phone=' + encode(mobile_phone) +
            '&dealer_name=' + encode(dealer_name) +
            '&address_1=' + encode(address_1) +
            '&address_2=' + encode(address_2) +
            '&postal_code=' + encode(postal_code) +
            '&city=' + encode(city) +
            '&country=' + encode(country) +
            '&organization_name=' + encode(organization_name) +
            '&location_installed=' + encode(location_installed)
        post(query, body, credentials, onDataReceived);
    }
}

export function setGatewayProperty(usingValueCode, credentials, propertyName, propertyValue, valueCode, onOk, onError) {
    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }
        if (Data.bpapi_status === 'ok') {
            onOk();
        } else {
            console.log("client_error");
            onError();
        }
    }

    let query;
    let body;
    if (usingValueCode) {
        query = 'Gateway/AddPropertySimple/'
        body = 'registration_id=' + valueCode + '&property_name=' + propertyName + '&value=' + encodeURIComponent(propertyValue);
        post(query, body, null, onDataReceived);
    } else {
        query = 'Gateway/AddProperty/'
        body = 'property_name=' + propertyName + '&value=' + encodeURIComponent(propertyValue);
        post(query, body, credentials, onDataReceived);
    }
}

export async function setSpecificGatewayIdProperty(usingValueCode, credentials, propertyName, propertyValue, valueCode, gatewayId, onOk, onError) {
    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }
        if (Data.bpapi_status === 'ok') {
            onOk();
        } else {
            console.log("client_error");
            onError();
        }
    }

    let query;
    let body;
    body = propertyName + '/' + propertyValue;
    if (usingValueCode) {
        query = 'Gateway/' + gatewayId + '/AddPropertySimple/' + body;
        post(query, null, credentials, onDataReceived);
    } else {
        query = 'Gateway/' + gatewayId + '/AddProperty/' + body;
        post(query, null, credentials, onDataReceived);
    }
}

export function cancelVippsAgreement(credentials, gateway_id, onOk, onError) {
    const query = 'Subscription/CancelVipps/' + gateway_id;

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }
        if (Data.bpapi_status === 'ok') {
            onOk();
        } else {
            console.log('client_error');
            onError();
        }
    }
    get(query, credentials, onDataReceived);
}

export function registerPayment(language, value_code, automaticLogin, subscription_type, hasMultipleGateways, credentials, onOk, onError, isVipps) {
    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }
        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_result.payment_completion_url);
        } else {
            console.log("client_error");
            onError();
        }
    }
    // If we have multiple gateways, we should not be logged in automatically when we return from NETS, as we have no password.
    // Todo: Will this be an issue from the phone app? (probably not, as a specific gateway is selected in the phone app)
    const sikomCallbackUrl = samRootUrl + '_QUESTION_language=' + language + '_AMP_valueCode=' + value_code + '_AMP_automaticLogin=' + automaticLogin;

    const singleGatewayMerchantUrl = sikomCallbackUrl;
    const multipleGatewaysMerchantUrl = sikomCallbackUrl + '_AMP_hasMultipleGateways=' + hasMultipleGateways;

    const singleGatewayCallbackUrl = sikomCallbackUrl + '_AMP_paymentStatus=';
    const multipleGatewaysCallbackUrl = sikomCallbackUrl + '_AMP_hasMultipleGateways=' + hasMultipleGateways + '_AMP_paymentStatus=';
    let query;
    let body;

    if (isVipps) {
        body = '?customer_id=' + value_code + '&subscription=' + subscription_type + '&callback_url=' + (hasMultipleGateways == true ? multipleGatewaysCallbackUrl : singleGatewayCallbackUrl) + '&merchant_url=' + (hasMultipleGateways == true ? multipleGatewaysMerchantUrl : singleGatewayMerchantUrl);
        query = 'Subscription/RegisterVippsPayment/' + body;

        post(query, null, null, onDataReceived);
    }
    else {
        query = 'Subscription/RegisterPayment/' + value_code + '/' + subscription_type + '/' + (hasMultipleGateways == true ? multipleGatewaysCallbackUrl : singleGatewayCallbackUrl);
        get(query, credentials, onDataReceived);
    }
}

// Sends a request to change the subscription type for a gateway. Requires proper authentication credentials.
// Value code login is not enough. 
export function changeSubscriptionForGateway(credentials, value_code, new_subscription_type) {
    const query = 'Gateway/' + value_code + '/ChangeSubscription/' + new_subscription_type;
    const emptyCredentials = {
        email: '',
        password: ''
    }

    let convertedCredentials;
    if (credentials !== null) {
        convertedCredentials = {
            email: credentials.email,
            password: credentials.password + '!!!'
        }
    }

    const credentialsToSend = credentials === null ? emptyCredentials : convertedCredentials
    const myHeaders = new Headers({
        'Authorization': 'Basic ' + btoa(credentialsToSend.email + ':' + credentialsToSend.password),
        'Content-Type': 'application/x-www-form-urlencoded',
    });

    return fetch(apiUrl + query, { method: 'GET', headers: myHeaders })
        .then(function (response) {
            const httpStatus = response.status;

            // Return if 401 (Unauthorized)
            if (httpStatus === 401) {
                return { success: false, status: 'Unauthorized', httpStatus: 401 };
            }

            // Authorized, check for bpapi_status. If 'ok', return success. Otherwise return the error from BPAPI.
            return response.json().then(function (json) {
                if (json && json.Data && json.Data.bpapi_status === 'ok') {
                    return { success: true, status: 'Success', data: json.Data.bpapi_result, httpStatus: httpStatus };
                }

                var status = (json && json.Data && json.Data.bpapi_status) ? json.Data.bpapi_status : 'SubscriptionChangeFailed';
                return { success: false, status: status, httpStatus: httpStatus };
            });
        })
        .catch((error) => {
            console.error('Network error:', error);
            return { success: false, status: 500, message: "Network error" };
        });
}

export function registerGoogleHome(credentials, clientId, onOk, onError) {
    const query = 'GoogleHomeRegister/' + clientId;

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }

        if (Data.bpapi_status === 'ok') {
            console.log("Google token received from API");
            onOk(Data.bpapi_result);
        } else {
            console.log("client_error");
            onError();
        }
    }

    get(query, credentials, onDataReceived);
}

/**
 * Download all receipts for this customer. The received data is a JSON list.
 * @param {*} credentials 
 * @param {*} onOk 
 * @param {*} onError 
 */
export function getReceipts(credentials, onOk, onError) {
    const query = "Customer/Receipts/" + credentials.email + '/' + encodeURIComponent(credentials.password) + '!!!/';

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError();
            return;
        }

        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_result);
        } else {
            console.log("client_error");
            onError();
        }
    }

    get(query, credentials, onDataReceived);
}

/**
 * Change the gateway ownership and send an email with information to the new customer
 * @param {*} credentials 
 * @param {*} onOk 
 * @param {*} onError 
 */
export function changeGatewayOwnership(credentials, value_code, email, password, new_email, onOk, onError) {
    const body = 'value_code=' + value_code + '&new_email=' + new_email
    // We were unable to POST this method without also adding the parameters to the query (as done below).

    // Making the API call identical (same format) to e.g. Customer/AddPropertyMultiple both in backend and frontend
    // always resulted in us not being able to trigger the corresponding API method in the controller and
    // a 405 when not adding the extra parameters. We therefore ended up just adding the parameters.

    // Note that it is important to have a trailing slash in the request, otherwise the query will not be
    // parsed correctly, since the new_email contains a dot(.)
    const query = 'Customer/ChangeGatewayOwnership/' + value_code + '/' + new_email + '/';

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError(null);
            return;
        }

        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_result);
        } else {
            console.log("client_error");
            onError(Data.bpapi_status);
        }
    }

    // We cannot use the default value code password to change this, so we change the credentials object
    // to use the input password instead.
    credentials.password = password;

    const newCredentials = {
        email: email,
        password: password,
    }

    post(query, body, newCredentials, onDataReceived);
}

/**
 * Replace one gateway with another, copying over relevant subscription information
 * @param {*} credentials
 * @param {*} onOk
 * @param {*} onError
 */
export function replaceGateway(credentials, old_value_code, new_value_code, email, password, onOk, onError) {
    const body = 'old_value_code=' + old_value_code + '&new_value_code=' + new_value_code;

    const query = 'Customer/ReplaceGateway/' + old_value_code + '/' + new_value_code + '/';

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError(null);
            return;
        }

        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_result);
        } else {
            console.log("client_error");
            onError(Data.bpapi_status);
        }
    }
    // We cannot use the default value code password to change this, so we change the credentials object
    // to use the input password instead.
    credentials.password = password;

    const newCredentials = {
        email: email,
        password: password,
    }
    post(query, body, newCredentials, onDataReceived);
}

/**
 * Assign an unassigned (free) gateway to the customer
 * @param {*} credentials 
 * @param {*} value_code 
 * @param {*} customer_id
 * @param {*} onOk 
 * @param {*} onError 
 */
export function addGateway(credentials, value_code, customer_id, onOk, onError) {
    const query = 'Gateway/' + value_code + '/Assign/' + customer_id;

    const onDataReceived = function response(Data) {
        if (Data == null) {
            onError(null);
            return;
        }

        if (Data.bpapi_status === 'ok') {
            onOk(Data.bpapi_result);
        } else {
            console.log("client_error");
            onError(Data.bpapi_status);
        }
    }

    get(query, credentials, onDataReceived);
}


// WEBPACK FOOTER //
// ./src/Networking/APIClient.js